export default __webpack_public_path__ + "static/media/MornSnow.5aaba64e.mp4";